import React, { useEffect, useState } from 'react';
import { Button, Form, Modal, Spin } from 'antd';
import { observer } from 'mobx-react';
import FormComponent from './FormComponent';
import useStore from '../../../../store';
import { Notification } from '../../../../config/Global';
import Message from '../../../../config/Message';

const EditComponent = observer((props) => {
	const { visible, onClose } = props;
	const [form] = Form.useForm();
	const { ADMINUSER, ROOT } = useStore();
	const { adminUserDetail } = ADMINUSER;
	const [disabled, setDisabled] = useState(true);
	const [saving, setSaving] = useState();

	const handleSubmit = (data) => {
		setSaving(true);
		ADMINUSER.editAdimnUser({
			...data,
			id: adminUserDetail.id,
			versionNo: adminUserDetail.versionNo,
		})
			.then(() => {
				ADMINUSER.adminUserDetail = null;
				Notification.success({
					message: Message().CRUD.UPDATE('User'),
				});
				closeModal();
			})
			.catch((e) => {
				const errorData = ROOT.assignErrorToInput(e);
				form.setFieldsValue({ error: errorData });
			})
			.finally(() => setSaving(false));
	};

	const handleChange = () => {
		setTimeout(() => {
			form.validateFields({ validateOnly: true })
				.then(() => {
					setDisabled(false);
				})
				.catch(() => {
					setDisabled(true);
				});
		}, 0);
	};

	const closeModal = () => {
		setDisabled(true);
		form.resetFields();
		ADMINUSER.adminUserDetail = null;
		onClose();
	};

	useEffect(() => {
		if (visible && adminUserDetail) {
			form.setFieldsValue({
				firstName: adminUserDetail.firstName,
				lastName: adminUserDetail.lastName,
				email: adminUserDetail.email,
				mobileNo: adminUserDetail.mobileNo,
				userName: adminUserDetail.userName,
				eAdminRoleId: adminUserDetail.eAdminRoleId,
			});
		}
	}, [visible, adminUserDetail]);

	return (
		<Modal
			title="Edit User"
			onCancel={closeModal}
			open={visible}
			destroyOnClose
			width={'500px'}
			footer={
				<div>
					<Button
						type="primary"
						key={1}
						disabled={disabled}
						htmlType="submit"
						loading={saving}
						form="EditForm"
					>
						Update User
					</Button>
					<Button key={2} onClick={closeModal}>
						Cancel
					</Button>
				</div>
			}
		>
			<Spin spinning={!ADMINUSER.adminUserDetail}>
				<FormComponent
					id="EditForm"
					form={form}
					onFinish={handleSubmit}
					handleChange={handleChange}
				/>
			</Spin>
		</Modal>
	);
});

export default EditComponent;
